import { combineReducers, applyMiddleware } from 'redux';
import createStore from '../../common/services/create-store';
import thunk from 'redux-thunk';
import createRequests from '../../common/services/create-requests';
import commonReducers from '../../common/reducers';
import archiveWidgetReducer from '../aggregated-archive/reducer';

export function createReduxStore({ appParams, wixCodeApi, compId, fedopsLogger, bundleName, flowAPI }) {
  const p = {};

  const { request, platformizedRequest, aggregatorRequest } = createRequests({
    appParams,
    wixCodeApi,
    bundleName,
    getStore: () => p.store,
    flowAPI,
  });

  const middleware = [
    thunk.withExtraArgument({
      request,
      platformizedRequest,
      wixCodeApi,
      compId,
      appParams,
      fedopsLogger,
      aggregatorRequest,
    }),
  ];

  const reducers = combineReducers({ ...commonReducers, archiveWidget: archiveWidgetReducer });

  const initialState = { experiments: flowAPI.essentials.experiments.all() };

  p.store = createStore(reducers, initialState, applyMiddleware(...middleware));

  return p.store;
}
